import { render, staticRenderFns } from "./GenericFieldsModule.vue?vue&type=template&id=fbcfae3a&"
import script from "./GenericFieldsModule.vue?vue&type=script&lang=js&"
export * from "./GenericFieldsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports